import React from "react";
import Slider from "react-slick";

import FlipText from '../StylisticComponents/FlipText';
import TimelineContainer from '../StylisticComponents/TimelineContainer';
import TextResources from '../../Resources/TextResources';
import { useState, useEffect, useRef } from 'react';
import CustomCard from "../StylisticComponents/CustomCard";
import TopBanner from "../StylisticComponents/TopBanner";

function Home() {
    

    const services = [
        "website development & design",
        "website hosting",
        "social media management",
        "graphic design",
        "social media marketing & PPC advertising",
        "branding & brand design",
        "advertising & paid media campaigns",
        "content creation",
        "video editing",
        "search engine optimization",
        "business consultation & coaching",
        "copywriting & ghostwriting",
        "funnel creation",
        "public relations",
        "community management & building"
    ];

    function handleResize() {
        return {
            speed: 500,
            slidesToScroll: 1,
            infinite: false,
            accessibility: true,
            slidesToShow: (window.innerWidth < window.innerHeight) ? 1 : 3,
        };

    };

    const [openedDesc, openDesc] = useState("timeline_1");
    const [visibility, setVis] = useState("visible");
    const [nextTimeline, setNext] = useState("timeline_2");
    const [sliderSettings, setSliderSettings] = useState(handleResize());
    const prevRef = useRef();
    useEffect(() => {
        setVis("hidden");
        setTimeout(() => {
            setVis("visible");       // Start fade-in
        }, 400);
        prevRef.current = openedDesc;
        let currTL = parseInt(openedDesc.charAt(openedDesc.indexOf('_') + 1));

        let nextVal = 0;
        if (currTL === 7) {
            nextVal = 1;
        } else {
            nextVal = currTL + 1;
        }

        setNext("timeline_" + nextVal.toString());

    }, [openedDesc]);
    useEffect(() => {
        const path = document.getElementsByClassName('timeline')[0];
        let offset = 0;

        const handleScroll = (e) => {
            // Change the offset based on scroll direction
            const delta = 1; // increase for faster scroll effect
            offset += delta;

            // Apply the new dash offset to create the movement effect
            path.style.strokeDashoffset = offset;
        };


        window.addEventListener("resize", () => {setSliderSettings(handleResize())});
        window.addEventListener('wheel', handleScroll);

        return () => {
            window.removeEventListener('wheel', handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (
        <div>
            <TopBanner>
                <h1 className="display-4 white-text hind-mysuru-bold">MapleMark Media</h1>
                <div className='row' style={{ marginLeft: 0 }}>
                    <div className='col-auto nopadding'><FlipText texts={services} prefix='We do&nbsp;' /></div>
                </div>
                <p className="main-font description-text white-text">that will accelarate your business' growth</p>
            </TopBanner>

            <div class="timeline-container">
                <div className="container">
                    <div className="row">
                        <h1 className="bebas-neue-regular orange-text">We're with you from start to finish</h1>
                    </div>
                </div>

                <svg class="timeline-svg" viewBox="0 0 1000 200" preserveAspectRatio="none">

                    <path className="timeline" d="M 0 100 C 250 200, 750 0, 1000 100" stroke="#6571b477" stroke-width="5" strokeDasharray="12 12"
                        strokeLinecap="round" fill="transparent" />

                </svg>
                <TimelineContainer nextUp={nextTimeline} changeDesc={openDesc} tl_id="1"></TimelineContainer>
                <TimelineContainer nextUp={nextTimeline} changeDesc={openDesc} tl_id="2"></TimelineContainer>
                <TimelineContainer nextUp={nextTimeline} changeDesc={openDesc} tl_id="3"></TimelineContainer>
                <TimelineContainer nextUp={nextTimeline} changeDesc={openDesc} tl_id="4"></TimelineContainer>
                <TimelineContainer nextUp={nextTimeline} changeDesc={openDesc} tl_id="5"></TimelineContainer>
                <TimelineContainer nextUp={nextTimeline} changeDesc={openDesc} tl_id="6"></TimelineContainer>
                <TimelineContainer nextUp={nextTimeline} changeDesc={openDesc} tl_id="7"></TimelineContainer>
            </div>
            <div className="container">
                <div className="d-flex justify-content-center">
                    <div className={`${visibility} timeline-info main-font`}><div className="hind-mysuru-semibold orange-text">{(openedDesc === "") ? TextResources[prevRef.current]["heading"] : TextResources[openedDesc]["heading"]}</div>{(openedDesc === "") ? TextResources[prevRef.current]["description"] : TextResources[openedDesc]["description"]}</div>
                </div>
            </div>

            <div className='mt-5'></div>

            <div className="container pt-5">
                <div className="row">
                    <h1 className="bebas-neue-regular orange-text">A Glimpse Into What We Can Do</h1>
                </div>
                <div className='mt-3'></div>
                <Slider {...sliderSettings}>
                    <CustomCard label="Website Creation" imagesrc="images/world-wide-web.png">
                        <p>Your website is arguably the most important part of your business. A seamless user experience and smooth technical performance are at the core of our custom web development solutions.</p>
                    </CustomCard>
                    <CustomCard label="Social Media Management" imagesrc="images/market-analysis.png">
                        <p>Boost your brand with our tailored social media management and marketing services. We are specialists when it comes to crafting your own unique brand stories on top social media platforms, ensuring your message resonates.</p>
                    </CustomCard>
                    <CustomCard label="Social Media Marketing & PPC Advertising" imagesrc="images/campaign.png">
                        <p>We help you reach your target audience with effective, tailored advertising campaigns. Our strategies across digital, social media, and traditional channels boost your brand's visibility, engagement, and conversions.</p>
                    </CustomCard>
                    <CustomCard label="Branding & Brand Design" imagesrc="images/brand-image.png">
                        <p>We help you create a strong and memorable brand identity. We develop logos, colour schemes, and messaging that reflect your values and resonate with your audience. From brand strategy to visual design, we ensure every element aligns with your vision and goals. Let us help you build a brand that stands out.</p>
                    </CustomCard>
                    <CustomCard label="Content Creation" imagesrc="images/creative.png">
                        <p>We create high-quality, tailored content to meet the diverse needs of your business. Whether you're looking to enhance your online presence, engage your audience, or drive sales, our team is here to deliver compelling and effective content that aligns with your brand's voice and goals.</p>
                    </CustomCard>
                    <CustomCard label="Graphic Design" imagesrc="images/graphic-design.png">
                        <p>We bring your ideas to life with creativity and precision. Whether starting from scratch or refining existing concepts, our expertise spans across digital and print media to ensure every design reflects your unique vision. Let us elevate your brand with impactful graphic solutions.</p>
                    </CustomCard>
                    <div>
                        <div className="service-card special-card">
                            <a href="/services">

                                <div className="row justify-content-center align-items-center" style={{ paddingTop: '10px', height: '100%' }}>
                                    <div className="col-12 text-center">
                                        <img
                                            src="images/Mascot-Glass-p-500.png"
                                            style={{ width: '50%' }}
                                            className="d-block mx-auto"
                                            alt="Mascot"
                                        />
                                        <p className="lead main-font">We can do a lot more. View our services</p>
                                    </div>
                                </div>
                            </a>
                        </div>

                    </div>
                </Slider>
            </div>
        </div>
    );
};
export default Home;